import { legacyTypeStyle } from "./templateTypeStyle";
import {
  BsFileEarmarkExcelFill as ExcelIcon,
  BsFileEarmarkPdfFill as PdfIcon,
  BsFileEarmarkWordFill as WordIcon,
  BsFillFileEarmarkFill as GenericFileIcon,
} from "react-icons/bs";

// Icon glyph is chosen by document format; its colour comes from the supplied
// type palette (defaults to the legacy palette, so consumers that don't opt in
// are unchanged — brand surfaces pass `typeStyle={brandTypeStyle}`).
const GLYPHS = {
  EXCEL: ExcelIcon,
  WORD: WordIcon,
  WORD_JINJA: WordIcon,
  ENDORSEABLE_WORD_JINJA: WordIcon,
  WORD_JINJA_ENDORSEMENT: WordIcon,
  PDF_ENDORSEMENT: PdfIcon,
  ENDORSABLE_PDF: PdfIcon,
};

const FileIcon = ({ type, typeStyle = legacyTypeStyle }) => {
  const Glyph = GLYPHS[type] ?? GenericFileIcon;
  return <Glyph color={typeStyle(type).fg} size={24} />;
};

export default FileIcon;
